module.exports = __webpack_public_path__ + "resources/img/bg_tcc_equipment.b11d05f8ab152ac5d1c077e485c399ed.jpg";